import type fa from './fa';

type DeepStringMap<T> = {
  [K in keyof T]: T[K] extends string ? string : T[K] extends object ? DeepStringMap<T[K]> : T[K];
};

const en: DeepStringMap<typeof fa> = {
  nav: {
    home: 'Home',
    games: 'Games',
    myGames: 'My Games',
    gallery: 'Media Showcase',
    contact: 'Contact Us',
    blog: 'Blog',
    about: 'About Us',
    terms: 'Terms & Conditions',
    login: 'Log In',
    signup: 'Sign Up',
    searchPlaceholder: 'Search games and videos...',
    openMenu: 'Open Menu',
    closeMenu: 'Close Menu',
    adminPanel: 'Admin Panel',
  },
  hero: {
    badge: '🎮 Independent Game Development Studio | Active Legend Studio',
    title: 'Active Legend Game Studio',
    subtitle: 'Pioneering competitive PC and online gaming developed with Unreal Engine 5',
    viewGames: 'Explore Games',
    login: 'Log In',
    signup: 'Sign Up',
  },
  games: {
    title: 'Games',
    metaTitle: 'Games | Active Legend - Indie Game Studio',
    metaDescription: 'Explore indie video games developed by Active Legend Studio. PC, competitive multiplayer, and Unreal Engine 5 projects.',
    downloadGame: 'Download Game',
    editGame: 'Edit Game',
    loading: 'Loading game information...',
    notFound: 'Game not found.',
    comingSoonTitle: 'Coming Soon / Not Released Yet',
    comingSoonDesc: 'This game has not been released yet and is currently in active development at our studio.',
    unavailableTitle: 'Download Currently Unavailable',
    unavailableDesc: 'No download build has been published yet. A playable release will be uploaded soon.',
    statusReleased: 'Released',
    statusInProgress: 'In Progress',
    statusComingSoon: 'Coming Soon',
    breadcrumbHome: 'Home',
    breadcrumbGames: 'Games',
    latestTitle: 'Latest Games from Studio',
    latestSubtitle: 'Featured projects and competitive games in active development with UE5',
    viewAllGames: 'View All Games',
    gamePage: 'Game Page',
    directDownload: 'Direct Download',
  },
  video: {
    watchOnYoutube: 'Watch on YouTube',
    openYoutube: 'YouTube',
    unavailable: 'Direct video playback is not available.',
    invalidUrl: 'Invalid video URL.',
    captionDefault: 'Game Video',
  },
  search: {
    loading: 'Searching...',
    noResults: 'No results found.',
    games: 'Games',
    videos: 'Videos',
    noneInCategory: 'Nothing found in this category.',
  },
  footer: {
    brandSubtitle: 'Independent Game Studio & Gaming Magazine',
    rights: 'All rights reserved',
    owner: 'Active Legend Studio',
    home: 'Home',
    games: 'Games',
    blog: 'Blog',
    contact: 'Contact',
    about: 'About',
    terms: 'Terms',
  },
  notFound: {
    title: '404',
    message: 'Page not found',
    backHome: 'Back to Home',
    metaTitle: 'Page Not Found (404) | Active Legend',
    metaDescription: 'The page you requested was not found. Return to Active Legend home.',
  },
  download: {
    title: 'Download File',
    wait: 'Please wait...',
    linkNotFound: 'Link not found',
    invalidId: 'The ID is invalid or the file does not exist.',
    backHome: 'Back to Home',
    countdown: 'Download begins in',
    seconds: 'seconds...',
    waitHint: 'Please wait until the countdown completes',
    downloadButton: 'Download File',
    manualHint: 'If download does not begin automatically, click the button above.',
    sponsorLabel: 'Sponsored',
  },
  media: {
    title: 'Media Showcase & Trailers',
    subtitle: 'Gameplay videos, trailers, and development screenshots',
    videoUnavailable: 'This video is currently unavailable.',
  },
  common: {
    loading: 'Loading...',
    language: 'Language',
    persian: 'فارسی',
    english: 'English',
  },
};

export default en;
